import {combineReducers} from 'redux';

export default combineReducers({

})


// WEBPACK FOOTER //
// ./src/reducers/admin/index.js